// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PdfOutlinedSvg from "@fishx/icons-svg/es/asn/PdfOutlined";
import FishxIcon from '../components/FishxIcon';

var PdfOutlined = function PdfOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PdfOutlinedSvg
  }));
};

PdfOutlined.displayName = 'PdfOutlined';
export default React.forwardRef(PdfOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PdfOutlined.js
// module id = 3763
// module chunks = 0